import Typography from "@material-ui/core/Typography";
import LinearProgress from "@material-ui/core/LinearProgress";
import React from "react";


const Loading = () => {
    return (
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', width:'100%'}}>
            <div style={{width: '50%'}}>
                <Typography>Loading...</Typography>
                <LinearProgress color="secondary"/>
            </div>
        </div>
    )
}

export default Loading;